var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorPage = function SvgErrorPage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 406,
    height: 306,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    fillOpacity: 0.16,
    d: "M148.403 60.808c-39.168 9.206-70.116 38.296-79.17 75.688-6.75 27.831-.822 56.536 44.61 66.99 98.201 22.594 204.299 15.093 217.047-30.034 12.749-45.127-10.911-122.53-67.081-127.321-31.983-2.751-79.992 6.384-115.406 14.677",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    fillOpacity: 0.16,
    d: "M198.9 257.007c76.276 0 138.111-7.298 138.111-16.301s-61.835-16.301-138.111-16.301c-76.277 0-138.111 7.298-138.111 16.301s61.834 16.301 138.111 16.301",
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    fillOpacity: 0.16,
    d: "m308.39 161.245-5.58-1.565-21.414 76.335 5.581 1.565z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D5E1",
    d: "M311.118 164.165a4.8 4.8 0 0 1-1.299-.183l-9.379-2.588a4.83 4.83 0 0 1-2.902-2.282 4.82 4.82 0 0 1-.437-3.666l1.887-6.729a4.83 4.83 0 0 1 5.948-3.35l9.359 2.629a4.83 4.83 0 0 1 3.339 5.958l-1.888 6.73a4.845 4.845 0 0 1-4.628 3.481m-.487-3.045a1.814 1.814 0 0 0 2.243-1.259l1.888-6.729a1.83 1.83 0 0 0-.16-1.389 1.8 1.8 0 0 0-1.099-.864l-9.358-2.619a1.82 1.82 0 0 0-1.383.164 1.81 1.81 0 0 0-.86 1.095l-1.888 6.729a1.82 1.82 0 0 0 1.258 2.243zM297.699 241.305l4.659-16.605-27.76-7.755-4.872 17.357a14.3 14.3 0 0 0-.193 7.044zM167.627 108.279h-14.189v134.914h14.189zM244.31 108.279h-14.189v134.914h14.189z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M167.627 108.279h-14.189v134.914h14.189zM244.31 108.279h-14.189v134.914h14.189z",
    opacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D5E1",
    d: "M261.17 125.027H136.639v43.929H261.17z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    d: "m142.953 125.027 14.88 43.929h20.584l-16.91-43.929zM181.066 125.027l14.88 43.929h20.584l-16.92-43.929zM219.067 125.027l14.88 43.929h20.584l-16.92-43.929z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D5E1",
    d: "M261.17 185.592H136.639v20.594H261.17zM103.53 234.626l12.444-57.266a2.554 2.554 0 0 1 2.492-1.981 2.554 2.554 0 0 1 2.491 1.981l13.581 58.22z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D5E1",
    d: "M133.868 229.105h-30.064a4.486 4.486 0 0 0-4.486 4.486v.619a4.486 4.486 0 0 0 4.486 4.486h30.064a4.486 4.486 0 0 0 4.487-4.486v-.619a4.486 4.486 0 0 0-4.487-4.486"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.868 229.105h-30.064a4.486 4.486 0 0 0-4.486 4.486v.619a4.486 4.486 0 0 0 4.486 4.486h30.064a4.486 4.486 0 0 0 4.487-4.486v-.619a4.486 4.486 0 0 0-4.487-4.486",
    opacity: 0.46
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m111.346 198.614 13.327-5.339 3.887 16.667-20.95 5.795z",
    opacity: 0.08
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    fillOpacity: 0.16,
    d: "M105.865 239.62s5.674-8.12-2.792-10.414c-8.465-2.294 2.03-13.246-5.846-14.697s-6.567 10.15-6.567 10.15-5.4-4.669-9.196-.711c-3.796 3.959 1.502 8.222 1.502 8.222s-7.582 2.619-2.852 7.409z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D5E1",
    d: "M94.476 240.706s3.603-6.171 8.922-5.41 4.74 5.41 4.74 5.41z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#369AFE",
    d: "m226.508 124.438 42.63 21.569a1.87 1.87 0 0 0 2.085-.288 1.87 1.87 0 0 0 .493-2.047l-.904-2.304a11.17 11.17 0 0 1 0-8.12c2.731-7.105 6.77-22.33-4.567-30.846-14.515-10.931-36.946-9.876-42.224 16.961a4.61 4.61 0 0 0 2.487 5.075"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m227.675 125.027 33.485 32.317v-15.387z",
    opacity: 0.08
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.628 108.543c2.588-3.624 7.816-9.013 16.057-9.237a1.461 1.461 0 0 1 .782 2.721 37.3 37.3 0 0 0-11.612 10.312 3.206 3.206 0 0 1-4.06 1.015 3.22 3.22 0 0 1-1.167-4.811",
    opacity: 0.31
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    fillOpacity: 0.16,
    d: "M101.317 130.751a7.102 7.102 0 0 0-8.252-7.003 9.58 9.58 0 0 0-8.434-5.075h-.356c.233-.902.352-1.83.356-2.761a11.379 11.379 0 1 0-22.757 0c.004.931.123 1.859.356 2.761h-.355a9.591 9.591 0 0 0 0 19.173h33.261v-.071a7.106 7.106 0 0 0 6.181-7.024M333.742 76.53a9.42 9.42 0 0 0-9.419-9.41 9.3 9.3 0 0 0-1.512.133 12.69 12.69 0 0 0-11.165-6.69h-.467c.305-1.19.462-2.414.467-3.643a15.073 15.073 0 1 0-30.136 0c-.005 1.253.149 2.5.457 3.715h-.467a12.7 12.7 0 0 0-12.19 12.688A12.7 12.7 0 0 0 281.5 86.01h44.051v-.091a9.41 9.41 0 0 0 8.191-9.39"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorPage);
export default ForwardRef;